/**
 * PATH: apps/hr/src/pages/payroll/PayRunDetailPage.tsx
 * PURPOSE: Pay run detail view
 *
 * ROLE IN ARCHITECTURE: Detailed pay run management
 *
 * NOTES FOR FUTURE AI:
 * - There is no pay-run API yet. This page must stay empty rather than
 *   showing sample employees or dollar totals.
 */

import { useNavigate } from 'react-router-dom'
import { ArrowLeft, DollarSign } from 'lucide-react'

export default function PayRunDetailPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate('/payroll')}
          className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-slate-600 dark:text-slate-400" />
        </button>
        <h1 className="text-xl font-semibold text-slate-900 dark:text-white">Pay run</h1>
      </div>
      <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-8 text-center">
        <DollarSign className="w-12 h-12 mx-auto text-slate-300 dark:text-slate-700 mb-3" />
        <p className="text-slate-500 dark:text-slate-400">No pay runs are connected.</p>
        <button
          type="button"
          onClick={() => navigate('/payroll')}
          className="mt-4 px-4 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700"
        >
          Back to Payroll
        </button>
      </div>
    </div>
  )
}
